const useSessionStorage = {
  set: (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data));
  },
  get: key => {
    return JSON.parse(sessionStorage.getItem(key));
  }
}

export default useSessionStorage;